import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup, useClosePopupOnNavigation } from '@gem/popups';
import { customScrollStyles, Divider } from '@gem/ui-kit';

import { SessionsTerminateButton } from '../SessionsTerminateButton/SessionsTerminateButton';
import { SessionItem } from './SessionItem/SessionItem';
import { SessionsPlaceholder } from './SessionsPlaceholder/SessionsPlaceholder';
import { useSessionsPopupPresenter } from './SessionsPopup.presenter';
import styles from './SessionsPopup.styles.m.css';

export const SessionsPopup: FC<ICommonPopupsProps> = observer((props) => {
  const { t } = useTranslation();
  const presenter = useSessionsPopupPresenter(props);
  useClosePopupOnNavigation(props.popupInstance);

  return (
    <Popup
      title={t('common_devices')}
      isOpened
      isHidden={props.popupInstance.isHidden}
      handlePrevStep={presenter.hasBackButton ? presenter.onBack : null}
      onClose={presenter.onClose}
    >
      <div className={classNames(styles.wrapper, customScrollStyles.container)}>
        <div className={styles.title}>{t('common_current_session')}</div>
        <SessionItem
          isOnline
          session={presenter.currentSession}
        />
        {(presenter.isLoading || !!Object.keys(presenter.sessions).length) && (
          <>
            {presenter.hasTerminateAll && (
              <SessionsTerminateButton
                isDisabled={presenter.isLoadingTerminateAll}
                onClick={presenter.onTerminateAllSessions}
              >
                {t('common_block_all_devices')}
              </SessionsTerminateButton>
            )}

            <Divider theme="style1" />
            {presenter.isLoading ? (
              <SessionsPlaceholder />
            ) : (
              <>
                {presenter.sessions.map(([key, sessions]) => {
                  return (
                    <>
                      <div className={styles.title}>{t(key)}</div>
                      {sessions.map((session) => (
                        <SessionItem
                          key={session.id}
                          session={session.device}
                          lastActivityTs={session.lastActivityTs}
                          onOpenSession={(): void =>
                            presenter.onOpenSession(session.device.deviceId)
                          }
                        />
                      ))}
                      <div className={styles.dividerBackground} />
                    </>
                  );
                })}
              </>
            )}
          </>
        )}
      </div>
    </Popup>
  );
});
